export enum TypeLotGroupEnum {
  appartement = 'Appartement',
  maison = 'Maison',
  parking = 'Stationnement',
  annexe = 'Annexe',
  terrain = 'Terrain',
  autre = 'Autre',
  localProfessionnel = 'Local professionnel'
}
